import { AfterViewInit, Component, Input, OnDestroy, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';

@Component({
  selector: 'app-gauge-chart',
  templateUrl: './gauge-chart.component.html',
  styleUrls: ['./gauge-chart.component.scss']
})
export class GaugeChartComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

  @Input() value: number;
  @Input() id: string;
  @Input() height: number = 200;
  @Input() innerRadius: number = 80;

  chart: any;
  viewInitialized = false;

  constructor() { }

  ngOnInit() { }

  ngOnDestroy(): void {
    if (this.chart) {
      this.chart.dispose();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!isNaN(this.value) && this.viewInitialized) {
      this.initChart();
    }
  }

  ngAfterViewInit() {
    this.viewInitialized = true;
    if (!isNaN(this.value)) {
      this.initChart();
    }
  }

  initChart() {
    setTimeout(() => this.createChart());
  }

  createChart() {
    if (this.chart) {
      this.chart.dispose();
    } else {
      am4core.useTheme(am4themes_animated);
    }

    this.chart = am4core.create(this.id, am4charts.GaugeChart);
    this.chart.innerRadius = am4core.percent(this.innerRadius);

    const axis = this.chart.xAxes.push(new am4charts.ValueAxis());
    axis.min = 0;
    axis.max = 100;
    axis.strictMinMax = true;

    const colorSet = new am4core.ColorSet();

    const axis2 = this.chart.xAxes.push(new am4charts.ValueAxis());
    axis2.min = 0;
    axis2.max = 100;

    const range0 = axis2.axisRanges.create();
    range0.value = 0;
    range0.endValue = this.value;
    range0.axisFill.fillOpacity = 1;
    range0.axisFill.fill = colorSet.getIndex(0);

    const range1 = axis2.axisRanges.create();
    range1.value = this.value;
    range1.endValue = 100;
    range1.axisFill.fillOpacity = 1;
    range1.axisFill.fill = am4core.color('#dbdbdb');

    const label = this.chart.radarContainer.createChild(am4core.Label);
    label.isMeasured = false;
    label.fontSize = 24;
    label.x = am4core.percent(this.value);
    label.y = am4core.percent(100);
    label.horizontalCenter = 'middle';
    label.verticalCenter = 'bottom';
    label.text = `${Math.round(this.value * 100) / 100}%`;
  }

}
